<script setup>
const props = defineProps({
  entry: { type: Object, required: true },
  desktopField: { type: String, default: 'imageDesktop' },
  mobileField: { type: String, default: 'imageMobile' }
})
const html = computed(() => props.entry?.conversationBox?.[0]?.html || '')
</script>

<template>
  <div class="conversation-image">
    <GlobalsImage
      :landscape="entry[desktopField]"
      :portrait="entry[mobileField]"
      :quality="100"
    />
    <GlobalsIsolatedHtml :html="html" class="conversation-image__overlay" />
  </div>
</template>

<style scoped>
.conversation-image {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  width: 100%;
}
.conversation-image :deep(picture),
.conversation-image :deep(img) {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.conversation-image__overlay {
  position: relative;
  z-index: 1;
}
</style>
